<div class="dialog" *ngIf="proposalOrderReduced.id">
  <div class="dialog__header clickable">
    <h3 class="section-title">RESUMO DO ORÇAMENTO</h3>
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <div class="budget-summary">
    <!-- position -->
    <div class="section" *ngIf="proposalOrderReduced.positionFunctions.length > 0">
      <h3 class="section-title">CARGOS</h3>
      <div class="item" *ngFor="let position of proposalOrderReduced.positionFunctions; let i = index">
        <p class="item-title">Cargo {{ i + 1 <= 9 ? '0' + (i + 1) : i + 1 }}</p>
            <table>
              <thead>
                <tr>
                  <th>Quantidade</th>
                  <th>Valor Unitário</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ position.quantity }}</td>
                  <td>{{ position.unitaryValue | currency:'BRL' }}</td>
                  <td>{{ position.totalValue | currency:'BRL' }}</td>
                </tr>
              </tbody>
            </table>
      </div>
      <div class="subtotal">
        <span class="info">Subtotal: </span>
        <span>
          {{ proposalOrderReduced.positionFunctionSubtotal | currency:'BRL' }}
        </span>
      </div>
    </div>

    <div class="line-separator" style="margin-left: 10px;"></div>

    <div class="section" *ngIf="proposalOrderReduced.materials.length > 0">
      <h3 class="section-title">MATERIAIS</h3>
      <div class="item" *ngFor="let material of proposalOrderReduced.materials; let i = index">
        <p class="item-title">Material {{ i + 1 <= 9 ? '0' + (i + 1) : i + 1 }}</p>
            <table>
              <thead>
                <tr>
                  <th>Quantidade</th>
                  <th>Valor Unitário</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ material.quantity }}</td>
                  <td>{{ material.unitaryValue | currency:'BRL' }}</td>
                  <td>{{ material.totalValue | currency:'BRL' }}</td>
                </tr>
              </tbody>
            </table>
      </div>
      <div class="subtotal">
        <span class="info">Subtotal: </span>
        <span>{{ proposalOrderReduced.materialsSubtotal | currency:'BRL' }} </span>
      </div>
    </div>

    <div class="line-separator" style="margin-left: 10px;"></div>

    <!-- R&S -->
    <div class="section" *ngIf="proposalOrderReduced.recruitmentAndSelections.length > 0">
      <h3 class="section-title">R&S</h3>
      <div class="item" *ngFor="let rs of proposalOrderReduced.recruitmentAndSelections; let i = index">
        <p class="item-title">R&S {{ i + 1 <= 9 ? '0' + (i + 1) : i + 1 }}</p>
            <table>
              <thead>
                <tr>
                  <th>Quantidade</th>
                  <th>Valor Unitário</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ rs.quantity }}</td>
                  <td>{{ rs.unitaryValue | currency:'BRL' }}</td>
                  <td>{{ rs.totalValue | currency:'BRL' }}</td>
                </tr>
              </tbody>
            </table>
      </div>
      <div class="subtotal">
        <span class="info">Subtotal: </span>
        <span>
          {{ proposalOrderReduced.recruitmentAndSelectionsSubtotal | currency:'BRL' }}
        </span>
      </div>
    </div>
  </div>

</div>